const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";
const APIHOST_V2 = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api/v2" : "https://www.christmaslistapp.com/api/v2";


function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function getMe(token) {
    console.log('GETTING LOGGED IN USER...');
    return fetch(APIHOST_V2 + "/users/me", {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getUser(userId, token) {
    console.log('GETTING USER...', userId);
    return fetch(APIHOST + "/users/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getShoppinglist(userId, token) {
    console.log('GETTING SHOPPING LIST...', userId);
    return fetch(APIHOST + "/shoppinglist/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getUserArchive(userId, token) {
    console.log('GETTING USER GIFT ARCHIVE...', userId);
    return fetch(APIHOST + "/archive/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function findByEmail(email, token) {
    console.log('SEARCHING USERS BY EMAIL...', email);
    return fetch(APIHOST + "/usersearch", {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        },
        method: 'POST', 
        body: JSON.stringify({ email: email }) 
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function updateUserProfile(userData, token) {
    console.log('UPDATE USER PROFILE...', userData);
    return fetch(APIHOST + "/users/" + userData.userID, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        },
        method: 'POST', 
        body: JSON.stringify(userData) 
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function createShareLink(linkData, token) {
    console.log('CREATING SHARE LINK...', linkData);
    return fetch(APIHOST_V2 + "/users/" + linkData.uid + "/sharelink", {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        },
        method: 'POST', 
        body: JSON.stringify(linkData) 
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('ERR', err);
        return err;
    });
}

export function getActivityFeed(userId, pg=1, token) {
    console.log('GETING USER ACTIVITY FEED...' + userId, pg);
    return fetch(APIHOST + "/activity/" + userId + "/" + pg, {
        headers: {
            'X-Cla-Authorization': token
        },
        method: 'GET'
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('ERR', err);
        return err;
    });
}
export function uploadAvatar(formData, userId, token) {
    console.log('UPLOADING AVATAR...' + userId, formData);
    return fetch(APIHOST + "/avatars/" + userId, {
        headers: {
            'X-Cla-Authorization': token
        },
        method: 'POST', 
        body: formData
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('ERR', err);
        return err;
    });
}